import React, { Fragment, useState } from "react";
import { ReactSVG } from "react-svg";
import { Modal } from "react-responsive-modal";

import "react-responsive-modal/styles.css";

import LoadingButton from "../commons/LoadingButton";
import CancelButton from "../commons/CancelButton";

import closeIcon from "icons/close.svg";

const BaseModal = ({
  open,
  name,
  title,
  introduction,
  body,
  cancel = {
    show: true,
    title: I18n.t("common.cancel")
  },
  confirm = {
    show: true,
    title: I18n.t("common.confirm"),
    loading: false,
    disabled: false,
  },
  showClose = true,
  onConfirm,
  onClose,
  onCloseAnimationEnd
}) => {

  const renderCloseIcon = () => (
    <ReactSVG className="icon" src={closeIcon} />
  );

  const renderHeader = () => (
    <Fragment>
      {title ? <div className="title">{title}</div> : null}
      {introduction ? <div className="introduction">{introduction}</div> : null}
    </Fragment>
  );

  const renderFooter = () => {
    if (!cancel?.show && !confirm?.show) return;
    return (
      <div className="footer">
        {cancel?.show ? (
          <CancelButton
            className="m-cancel-btn"
            title={cancel?.title}
            disabled={confirm?.loading}
            onClick={onClose}
          />
        ) : null}
        {confirm?.show ? (
          <LoadingButton
            filled
            className="confirm-btn"
            title={confirm?.title}
            loading={confirm?.loading}
            disabled={confirm?.disabled}
            onClick={onConfirm}
          />
        ) : null}
      </div>
    );
  }

  return (
    <Modal
      modalId={`${name}-modal`}
      open={open}
      showCloseIcon={showClose}
      closeOnEsc={false}
      closeIcon={renderCloseIcon()}
      classNames={{
        modal: `app-modal ${name}-modal`,
        closeButton: "close-action-btn",
        closeIcon: "close-action-btn.icon"
      }}
      onClose={onClose}
      onAnimationEnd={() => !open && onCloseAnimationEnd && onCloseAnimationEnd()}
    >
      {renderHeader()}
      <div className="modal-body">
        {body}
      </div>
      {renderFooter()}
    </Modal>
  );
}

export default BaseModal;
